// generated by genversion
export var version = '3.4.0';
//# sourceMappingURL=version.js.map